import { hwoModel } from '../../api';
import { setError, setLoading, setShowEmptyState } from '../orders/actions';
import { sendEventToJumbo } from '../../helpers/analytics';

export const SET_HANDOVER_DATA = 'SET_HANDOVER_DATA';
export const setHandoverData = (data) => ({
  type: SET_HANDOVER_DATA,
  data,
});

export const getHandoverData = (params) => (dispatch) => {
  return hwoModel
    .getHandoverData(params)
    .then((response) => {
      if (!response || (response && response.isError)) {
        dispatch(setError(true));
        dispatch(setLoading(false));
        return response;
      }
      sendEventToJumbo('get_handover_wo_data_success');
      dispatch(setHandoverData(response));
      setShowEmptyState(false);
      setLoading(true);
    })
    .catch((err) => {
      sendEventToJumbo('get_handover_wo_data_failed', { err });
      console.log('handover error', err);
      dispatch(setError(true));
      dispatch(setLoading(false));
    });
};
